import * as dotProp from 'dot-prop-immutable';
import dotPropCombine from '../../util/dotProp';
import { getStateFromPressingBack } from '../../util/decisionTreeUtil';
import { CLEAR_SNIPPET_TEXT, SET_SNIPPET_TEXT, ADD_SNIPPET_TEXT } from '../../constants/ordersSearchActionTypes';
import * as types from 'actions/types';

// fields that we track whenever the user presses back
const trackedInitialState = {
  tagPath: '',
  selectedMacro: null,
  noMatchPageActivated: false,
  decisionTreePath: '',
  loading: false,
  pathWasReset: false,
};

export const trackedFields = Object.keys(trackedInitialState);

const INITIAL_STATE = {
  macrosByTagPath: {},
  decisionFlowsData: {},
  snippetTextList: [],
  taggingActive: false,
  restartDecisionFlowData: {},
  ...trackedInitialState,
};

const macroWizard = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.SET_LOADING_FOR_MACRO_WIZARD:
      return dotProp.set(state, 'loading', action.value);
    case types.SET_MACROS_BY_TAG_PATH:
      return dotProp.set(state, 'macrosByTagPath', action.macroListByPath);
    case types.SET_DECISION_FLOWS_DATA:
      return dotProp.set(state, 'decisionFlowsData', action.decisionFlowsData);
    case 'ADD_EDGE_TO_DECISION_TREE_PATH':
      let { decisionTreePath } = state;
      // add the edge to the decision tree
      // add spacer if needed
      if (decisionTreePath) {
        decisionTreePath += ' -- ';
      }
      decisionTreePath += action.choice;

      return dotPropCombine(state, {
        decisionTreePath,
        selectedMacro: null,
      });
    case 'SET_MACRO_WIZARD_PATH':
      // tracked params revert to initial state
      return dotPropCombine(
        state,
        Object.assign({}, trackedInitialState, {
          tagPath: action.tagPath,
        })
      );
    case types.SET_DECISION_TREE_PATH:
      return dotProp.set(state, 'decisionTreePath', action.decisionTreePath);
    case 'SET_TAGGING_ACTIVE':
      return dotProp.set(state, 'taggingActive', action.value);
    case 'CLEAR_MACRO_WIZARD_PATH':
      return dotPropCombine(state, trackedInitialState);
    case 'SET_SELECTED_WIZARD_MACRO':
      // update last path as well
      return dotPropCombine(state, {
        selectedMacro: action.macro,
      });
    case 'CLEAR_SELECTED_WIZARD_MACRO':
      return dotPropCombine(state, {
        selectedMacro: null,
      });
    case 'SET_NO_MATCH_PAGE':
      return dotProp.set(state, 'noMatchPageActivated', action.value);
    case 'RETURN_TO_PREVIOUS_MACRO_PATH':
      state = getStateFromPressingBack(state);

      return dotProp.set(state, 'snippetTextList', []);
    case CLEAR_SNIPPET_TEXT:
      return dotProp.set(state, 'snippetTextList', []);
    case ADD_SNIPPET_TEXT:
      const { snippetTextList } = state;
      snippetTextList.push(action.text);

      return dotProp.set(state, 'snippetTextList', snippetTextList);
    case SET_SNIPPET_TEXT:
      return dotProp.set(state, 'snippetTextList', action.snippetTextList);
    case types.CLEAR_SEARCH:
      return INITIAL_STATE;
    case types.RESTART_DECISION_FLOW_REQUESTED:
      return dotProp.set(state, 'restartDecisionFlowData', action.restartDecisionFlowData);
    case types.SET_PATH_WAS_RESET:
      return dotProp.set(state, 'pathWasReset', action.value);
    default:
      return state;
  }
};

export default macroWizard;
